export interface IPaymentMP {
	installments: number;
	issuer_id: string;
	payer: IPaymentMPPayer;
	payment_method_id: string;
	token: string;
	transaction_amount: number;
}

export interface IPaymentMPPayer {
	email: string;
	identification: IPaymentMPPayerIdentification;
}

export interface IPaymentMPPayerIdentification {
	type: string;
	number: string;
}

export interface IPayment {
	id?: string;
	number?: string;
	name?: string;
	securityNumber?: string;
	method?: string;
	expiresAt?: string;
	type?: string;
	brand?: string;  // Card brand: visa, mastercard, amex, etc.
	exist?: boolean;
}

export enum PATMENT_TYPE_ENUM {
  CARD = 'card',
  ACCOUNT_MONEY = 'account_money',
}

export interface IPaymentItem {
	name: string;
	icon: string;
	selected: boolean;
	tag?: string;
}
